import { render } from "./DataGraph.vue?vue&type=template&id=20ff77f5"
import script from "./DataGraph.vue?vue&type=script&lang=js"
export * from "./DataGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__